import { useAuth } from "react-oidc-context";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  link: {
    color: "#474747 !important",
    display: "inline-block",
    textAlign: "center",
    margin: "0 15px 0 0 !important",
    textDecoration: "none !important",
    "&:hover": { cursor: "pointer" },
    "&.t-logout": {
      fontSize: "24px  !important",
    },
  },
  label: {
    fontSize: "12px  !important",
  },
});

const LogoutButton = () => {
  const classes = useStyles();
  const { signoutRedirect } = useAuth();
  
  return (
    <Link
      className={classes.link}
      onClick={() =>
        signoutRedirect()
      }
      data-testid="logout-button"
    >
      <div className="t-logout"></div>
      <div className={classes.label}>Logout</div>
    </Link>
  );
};

export default LogoutButton;
